var ubian = ubian || {};

ubian.zones = {};

/**
 * zones on currently selected route (comma delimited list)
 * @type String
 */
ubian.zones.selectedRoute = null;

/**
 * array of ids of selected zones
 * @type Array
 */
ubian.zones.selectedZones = [];

/**
 *
 * @param {type} zones
 * @returns {undefined}
 */
ubian.zones.addZones = function (zones, noDisplay) {
  $(zones).each(function (i, zoneElement) {
    var zone = parseInt(zoneElement);
    if (ubian.zones.selectedZones.indexOf(zone) === -1) {
      ubian.zones.selectedZones.push(zone);
      if (zone === 100 && ubian.zones.selectedZones.indexOf(101) === -1) {
        ubian.zones.selectedZones.push(101);
      }
    }
  });
  ubian.zones.refreshSelectedZonesList(noDisplay);
};
/**
 * get zone from list of zones by its id
 * @param {int} id
 * @returns {zone}
 */
ubian.zones.getZoneById = function (id) {
  var result = null;
  $(ubian.zonesList).each(function (i, zone) {
    if (zone.id === id) {
      result = zone;
      return false;
    }
  });
  return result;
};
/**
 * remove selected zone from list of selected zones
 * @param {int} id
 * @returns {undefined}
 */
ubian.zones.removeSelectedZone = function (id) {
  var idx = ubian.zones.selectedZones.indexOf(Number.parseInt(id));
  if (idx > -1) {
    ubian.zones.selectedZones.splice(idx, 1);
    ubian.zones.refreshSelectedZonesList();
  }
};

/**
 * refresh the displayed list of selected zones
 * @returns {undefined}
 */
ubian.zones.refreshSelectedZonesList = function (noDisplay) {
  if (!noDisplay) {
    $(".js-zones-errors").hide();
    $(".js-zones-list").html("");
    $(".js-zones-list-mobile").html("");
    var html = "";
    var htmlMobile = "";
    var templateMobile = $("#js-mobile-zone-item").html();

    $(ubian.zones.selectedZones).each(function (i, zoneID) {
      var mobile = templateMobile;
      var zone = ubian.zones.getZoneById(zoneID);

      html +=
        "<tr><td>" +
        zone.name +
        "</td><td>" +
        zone.id +
        '</td><td><a href="#" class="js-remove-selected-zone" data-id="' +
        zone.id +
        '"><span aria-hidden="true">&times;</span></a></td></tr>';
      mobile = mobile.replace("%name%", zone.name);
      mobile = mobile.replace("%code%", zone.id);
      mobile = mobile.replace("%id%", zone.id);
      htmlMobile += mobile;
    });
    $(".js-zones-list").html(html);
    $(".js-zones-list-mobile").html(htmlMobile);
  }
  errors = [];
  if (ubian.zones.isNetwork()) {
    errors.push(ubian.translate("JS.Error.Zones.Network"));
  }
  if (true !== (validMsg = ubian.zones.isValid())) {
    errors.push(validMsg);
  }
  if (!noDisplay) {
    if (errors.length) {
      $(".js-zones-errors .text").html(errors.join("<br />"));
      $(".js-zones-errors").show();
    }
    ubian.zones.toggleConfirmButtonState();
  } else {
    if (errors.length) {
      ubian.utils.alert(errors.join("<br />"), null, 'OK', function () {
        ubian.zones.confirmZonesSelection();
      });
    } else {
      ubian.zones.confirmZonesSelection();
    }
  }
};
/**
 * toggle confirm button state depending on validity of selected zones list
 * @returns {undefined}
 */
ubian.zones.toggleConfirmButtonState = function () {
  var btn = $(".js-confirm-zones-selection");
  btn.removeClass("btn-green");
  btn.removeClass("btn-transparent-gray disabled");
  if (ubian.zones.selectedZones.length && ubian.zones.isValid() === true) {
    btn.addClass("btn-green");
  } else {
    btn.addClass("btn-transparent-gray disabled");
    if (__ubian_branding != "DPB") {
      btn.addClass("disabled");
    }
  }
};
/**
 * returns whether zones list should be considered as NETWORK
 * @returns {Boolean}
 */
ubian.zones.isNetwork = function () {
  if (
    ubian.zones.selectedZones.indexOf(100) > -1 &&
    ubian.zones.selectedZones.length > 9
  ) {
    return true;
  }
  if (
    ubian.zones.selectedZones.indexOf(100) === -1 &&
    ubian.zones.selectedZones.length > 10
  ) {
    return true;
  }
  return false;
};
/**
 * return true if list of zones is valid, error message otherwise
 * @returns {Boolean|String}
 */
ubian.zones.isValid = function () {
  if (
    ubian.zones.selectedZones.length === 1 &&
    ubian.zones.selectedZones[0] === 101
  ) {
    return ubian.translate("JS.Error.Zones.SingleZone101");
  }
  return true;
};
/**
 * Add zones from selected route
 * @returns {undefined}
 */
ubian.zones.addSelectedRoute = function () {
  if (!ubian.zones.selectedRoute) {
    return;
  }
  var route = ubian.zones.selectedRoute.split(",");
  var zones = [];
  $(route).each(function (i, zone) {
    zones.push(zone.replace(/[^0-9]+/, ""));
  });
  ubian.zones.addZones(zones);
};
/**
 * update list of zones for specified FROM-TO
 * update selectbox with available VIA points from routes
 * @param {type} routes
 * @returns {undefined}
 */
ubian.zones.updateVia = function (routes) {
  if (routes.length === 0) {
    return;
  }
  if (routes.length === 1) {
    $(".js-found-zones").html(routes[0].zoneNumbers);
    ubian.zones.selectedRoute = routes[0].zoneNumbers;
    $(".js-confirm-route-selection").removeClass("btn-transparent-gray");
    $(".js-confirm-route-selection").addClass("btn-green");
  } else {
    $(".js-found-zones").html(ubian.translate("JS.Zones.SelectVia"));
    ubian.zones.selectedRoute = null;
    var options = '<option value=""></option>';

    $(routes).each(function (i, route) {
      options +=
        '<option value="' +
        route.zoneNumbers +
        '">' +
        route.description +
        "</option>";
    });
    $("select.js-place-via").html(options);
    $("select.js-place-via").selectpicker("refresh");
    $(".js-place-via-control").show();
    $(".js-place-via-control").change(function () {
      $(".js-confirm-route-selection").removeClass("btn-transparent-gray");
      $(".js-confirm-route-selection").addClass("btn-green");
    });
  }
};
/**
 * request list of available routes for specified cities
 * @returns {undefined}
 */
ubian.zones.requestRoutes = function () {
  $("select.js-place-via").html("");
  $(".js-place-via-control").hide();

  ubian.zones.selectedRoute = null;
  // var from = $(".js-place-from option:selected").val();
  // var to = $(".js-place-to option:selected").val();
  var from =  ubian.zones._placeFromValue;
  var to = ubian.zones._placeToValue;
  if (from === to) {
    ubian.utils.alert(ubian.translate("JS.Error.Zones.Incorrect"));
    return;
  }
  if (from && to) {
    $(".js-found-zones").html(
      '<i class="general-loader-icon"></i>' +
      ubian.translate("JS.Zones.SearchingRoutes")
    );
    $.post(
      ubian.routes["time_ticket_get_routes"],
      {
        from: from,
        to: to,
      },
      function (res) {
        if (
          res.routes.length === 1 &&
          res.routes[0].zoneNumbers === "NETWORK"
        ) {
          var url = ubian.routes["time_ticket_select_type"];
          url = url.replace("company_id", ubian.zonesCompanyId);
          url = url + "?zones=NETWORK";
          ubian.utils.confirm(
            ubian.translate("JS.Error.Zones.Network"),
            "",
            ubian.translate("Button.OK"),
            url
          );
          $(".js-found-zones").text("");
        } else {
          ubian.zones.updateVia(res.routes);
        }
      }
    );
  }
};
/**
 * confirm zones selection and redirect to selection of type of time ticket
 * @returns {undefined}
 */
ubian.zones.confirmZonesSelection = function () {
  if (!(ubian.zones.isValid() === true && ubian.zones.selectedZones.length))
    return;

  $.get(
    ubian.routes["time_ticket_get_Routes_For_Zones"],
    {
      zoneIDs: ubian.zones.selectedZones,
    },
    function (res) {
      //console.log(res); console.log(ubian.zones);
      var zoneNumbersIsNetwork = false;
      var selectedIdx = -1;
      if (res.routes.length === 1 && res.routes[0].zoneNumbers == "NETWORK") {
        zoneNumbersIsNetwork = true;
      } else {
        var selectedZonesString = [];
        $(ubian.zones.selectedZones).each(function (j, zone) {
          selectedZonesString.push(zone.toString().replace(/[^0-9]+/, ""));
        });
        selectedZonesString = JSON.stringify(selectedZonesString.sort());

        for (var i = 0; i < res.routes.length; i++) {
          var zones = [];
          var route = res.routes[i].zoneNumbers.split(",");
          $(route).each(function (j, zone) {
            zones.push(zone.replace(/[^0-9]+/, "").toString());
          });
          zones.sort();
          var zonesString = JSON.stringify(zones);
          if (selectedZonesString == zonesString) {
            selectedIdx = i;
            break;
          }
        }
      }

      if (selectedIdx == -1 && !zoneNumbersIsNetwork) {
        var dialog = $($('#js-confirmRouteSelection-dialog').html());
        $(dialog).modal();
        $(dialog).find('.js-submit-confirm-route-selection').click(function () {
          var listControl = $(dialog).find("#js-select-confirm-route-selection");
          var selectedzoneNumbers = listControl.val();
          var url = ubian.routes["time_ticket_select_type"];
          url = url.replace("company_id", ubian.zonesCompanyId);
          url += "?zones=" + selectedzoneNumbers;
          window.location = url;
        });

        var listControl = $(dialog).find("#js-select-confirm-route-selection");
        var options = '<option disabled >' + ubian.translate("Title.TimeTicket.SelectedDiscontinuousCombination") + '</option>';
        options += '<option selected value="' + ubian.zones.selectedZones.join(",") + '">' + ubian.zones.selectedZones.join(", ") + "</option>";
        options += '<option disabled >' + ubian.translate("Title.TimeTicket.PossibleContinuousCombinations") + '</option>';
        $(res.routes).each(function (i, route) {
          options += '<option value="' + route.zoneNumbers.split(", ").join(",") + '">' + route.zoneNumbers.split(", ").join(", ")
            + ' - ' + route.description + "</option>";
        });
        listControl.html(options);
      } else {
        var url = ubian.routes["time_ticket_select_type"];
        url = url.replace("company_id", ubian.zonesCompanyId);
        url +=
          "?zones=" +
          (ubian.zones.isNetwork() || zoneNumbersIsNetwork
            ? "NETWORK"
            : ubian.zones.selectedZones.join(","));
        window.location = url;
      }
    }
  );
};

$(function () {
  $(".js-place-from, .js-place-to").change(function () {
    ubian.zones.requestRoutes();
  });
  $(".js-place-via").change(function () {
    var zones = $(this).find("option:selected").val();
    $(".js-found-zones").html(zones);
    ubian.zones.selectedRoute = zones ? zones : null;
  });
  $(".js-confirm-route-selection").click(function () {
    ubian.zones.addSelectedRoute();
    return false;
  });

  $(".js-confirm-zones-selection").click(function () {
    ubian.zones.confirmZonesSelection();
    return false;
  });
  $(".js-add-zone").click(function () {
    // var id = $(".js-pick-zone-single option:selected").val();
    var id = ubian.zones._pickZoneValue;
    if (id) {
      ubian.zones.addZones([id]);
    }
    return false;
  });
  //init easyAutocomplete for pickZone, placeFrom, placeTo
  $('input[data-list]').each(function () {
    var ds = $('#' + $(this).attr("data-list")).find('option').map(function () {
      return {label: this.label, value:this.value};
    }).get();
    var inputID= this.id;
    if(inputID == "pickZone" && ds && ds.length){
      $(this).val(ds[0].label);
      ubian.zones._pickZoneValue =ds[0].value;
    }
    var options = {
      data: ds,
      cssClasses: 'eshop-easy-autocomplete',
      getValue: function(element) {
        return element.label;
      },
      list: {
        maxNumberOfElements: 50,
        match: {
          enabled: true,
          method: function (element, phrase) {
            var normalizedElement=element.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            var normalizedPhrase=phrase.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            return normalizedElement.search(normalizedPhrase) > -1;
          }
        },
        onChooseEvent:function() {
          var sel = $("#"+ inputID).getSelectedItemData();
          ubian.zones["_" + inputID + "Value"] = sel.value; //_pickZoneValue,_placeFromValue,_placeToValue
          if(["placeFrom","placeTo"].indexOf(inputID) != -1)
            ubian.zones.requestRoutes();
        },
        onShowListEvent:function() {
          $("#"+ inputID).parent().find(".easy-autocomplete-container").addClass("easy-autocomplete-container-open");
        },
        onHideListEvent:function() {
          $("#"+ inputID).parent().find(".easy-autocomplete-container").removeClass("easy-autocomplete-container-open");
        }
      },
    };
    $(this).easyAutocomplete(options).click(function(){ 
      $(this).val('').triggerHandler(jQuery.Event("keyup", { keyCode: 65, which: 65}));
    });
  });

  $(document).on("click", ".js-remove-selected-zone", function () {
    ubian.zones.removeSelectedZone($(this).data("id"));
    return false;
  });
});
